import BadgeSB from '@/components/atoms/badge/BadgeSB';
import { HeaderItemLevel } from '@/components/atoms/layout/header/HeaderSB';
import LinkButton from '@/components/atoms/linkButton';
import { transformFromCMSLink } from '@/components/atoms/linkButton/LinkSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { PricePer, PricePerProps } from '@/features/shared/PricePer';

type HeaderNavItemSBProps = HeaderItemLevel<{
  description?: string;
  price?: PricePerProps;
}>;

export default function HeaderNavItemSB({
  block,
}: BlockComponentModel<HeaderNavItemSBProps>) {
  const { title, link } = block;

  if (!link?.url) {
    return <HeaderNavItemContent {...block} />;
  }

  return (
    <div className='min-w-[200px] max-w-[400px]'>
      <LinkButton
        {...transformFromCMSLink(link)}
        variant='text'
        underline={false}
        classNames={{
          root: 'hover:bg-neutral-N94 p-3 h-auto justify-normal w-full group',
          inner: 'w-full',
        }}
        data-tracker-context={String(title)}
      >
        <HeaderNavItemContent {...block} />
      </LinkButton>
    </div>
  );
}

const HeaderNavItemContent = ({
  badge,
  description,
  price,
  title,
}: Pick<HeaderNavItemSBProps, 'badge' | 'title' | 'description' | 'price'>) => (
  <div className='flex w-full flex-row items-center justify-between gap-9'>
    <div className='flex flex-col gap-2'>
      <div className='flex items-center gap-2'>
        <p className='text-body-l text-neutral-N00'>{title}</p>
        {badge && (
          <BadgeSB block={badge} inner={{ size: 's', variant: 'outlined' }} />
        )}
      </div>
      {description && (
        <div>
          <p className='text-neutral-N40 text-body-s max-w-[200px] text-wrap'>
            {description}
          </p>
        </div>
      )}
    </div>
    {price && <PricePer {...price} />}
  </div>
);
